import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { deleteSubStep, setActiveStep } from "../actions";
import breadcrumbs from "../utils/breadcrumbs";
import { STEP_SEPARATOR } from "../utils/constants";
import { searchSelfRemoveSubStep, searchStep } from "../utils/scenario-manager";
import { Breadcrumbs as MaterialBreadcrumbs } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import { getCurrentStep } from "../utils/fetcher";

class Breadcrumbs extends Component {
  handleClickItem = crumbKey => {
    if (getCurrentStep().step >= 2) {
      this.props.breadcrumbsCancelAppointment(
        () => this.handleClick(crumbKey),
        true
      );
    } else {
      this.handleClick(crumbKey);
    }
  };
  handleClick = crumbKey => {
    const currentActiveStep = { ...this.props.activeStep };
    const [crumbStep, crumbSubStep] = crumbKey.split(STEP_SEPARATOR);
    const toActiveStep = { step: +crumbStep, subStep: +crumbSubStep };
    this.props.updateBreadcrumbs(this.props.activeStep, toActiveStep);
    this.props.setActiveStep(toActiveStep);

    const destStep = searchStep(this.props.steps, toActiveStep);
    if (destStep) {
      const fromStep = searchStep(this.props.steps, currentActiveStep);
      if (fromStep) {
        if (fromStep.selfRemove.group && !destStep.selfRemove.group) {
          const subStepToRemove = searchSelfRemoveSubStep(
            this.props.steps,
            fromStep.selfRemove.group
          );
          for (const key in subStepToRemove) {
            if (Object.prototype.hasOwnProperty.call(subStepToRemove, key)) {
              const [stepIndex, subStepIndex] = key.split(STEP_SEPARATOR);
              this.props.deleteSubStep(+stepIndex, +subStepIndex);
            }
          }
        }
      }
    }
  };

  buildBreadcrumbsHtml = () => {
    const crumbs = [];
    const itemsBreadcrumbs = this.props.itemsBreadcrumbs;
    for (const crumb in itemsBreadcrumbs) {
      if (Object.prototype.hasOwnProperty.call(itemsBreadcrumbs, crumb)) {
        if (!this.props.user.isUserArea) {
          crumbs.push(
            <Link
              color="primary"
              onClick={() => this.handleClickItem(crumb)}
              key={crumb}
            >
              {itemsBreadcrumbs[crumb]}
            </Link>
          );
        } else {
          crumbs.push(
            <Typography color="primary" key={crumb}>
              {itemsBreadcrumbs[crumb]}
            </Typography>
          );
        }
      }
    }
    return crumbs;
  };

  render() {
    return (
      <MaterialBreadcrumbs
        maxItems={2}
        className="breadcrumbs"
        aria-label="breadcrumb"
        separator="›"
      >
        {this.buildBreadcrumbsHtml()}
      </MaterialBreadcrumbs>
    );
  }
}

Breadcrumbs.propTypes = {
  activeStep: PropTypes.any,
  breadcrumbsCancelAppointment: PropTypes.func,
  deleteSubStep: PropTypes.func,
  itemsBreadcrumbs: PropTypes.shape({
    hasOwnProperty: PropTypes.func
  }),
  setActiveStep: PropTypes.func,
  steps: PropTypes.any,
  updateBreadcrumbs: PropTypes.func,
  user: PropTypes.shape({
    isUserArea: PropTypes.any
  })
};

const mapStateToProps = state => {
  return {
    steps: state.steps,
    activeStep: state.activeStep,
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {
    setActiveStep: activeStep => dispatch(setActiveStep(activeStep)),
    updateBreadcrumbs: (from, to) => dispatch(breadcrumbs(from, to)),
    deleteSubStep: (stepIndex, subStepIndex) =>
      dispatch(deleteSubStep(stepIndex, subStepIndex))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Breadcrumbs);
